import React from 'react';
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { Benefits } from './components/Benefits';
import { HowItWorks } from './components/HowItWorks';
import { FAQ } from './components/FAQ';
import { Testimonials } from './components/Testimonials';
import { Partners } from './components/Partners';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen flex flex-col font-sans" data-id="element-0">
      <Header data-id="element-1" />
      <main className="flex-grow" data-id="element-2">
        <Hero data-id="element-3" />
        <Benefits data-id="element-4" />
        <HowItWorks data-id="element-5" />
        <FAQ data-id="element-6" />
        <Testimonials data-id="element-7" />
        <Partners data-id="element-8" />
      </main>
      <Footer data-id="element-9" />
    </div>;
}